/**
 * Shared layout constants — single source of truth for spacing, widths, and gradients.
 * Used by SidebarPage, PageHeader, and all page-level layouts.
 */

// Sidebar
export const SIDEBAR_WIDTH = 380
export const SIDEBAR_COLLAPSED_WIDTH = 48

// Page header
export const PAGE_HEADER_PADDING = 2.75 // MUI spacing units (22px)
export const PAGE_HEADER_PADDING_BOTTOM = 3.25 // slightly more at bottom (26px)
// Kept for reference if accent bars are re-enabled per customer
// export const PAGE_HEADER_ACCENT_HEIGHT = '4px'

// Content area
export const CONTENT_MARGIN = 3 // MUI spacing units (24px)

// Customer-themeable accent gradient
// This is the default — will be overridden per-customer from config
export const DEFAULT_ACCENT_GRADIENT = '#00B2FF'
